import { render, staticRenderFns } from "./homeCompany.vue?vue&type=template&id=3d0c778c&scoped=true&"
import script from "./homeCompany.vue?vue&type=script&lang=js&"
export * from "./homeCompany.vue?vue&type=script&lang=js&"
import style0 from "./homeCompany.vue?vue&type=style&index=0&id=3d0c778c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0c778c",
  null
  
)

export default component.exports